<table class="simple-table">
  <thead>
    <tr>
      <th>Series</th>
      <th>Description</th>
      <th>Measured</th>
      <th>Adjusted</th>
      <th>Error</th>
    </tr>
  </thead>
  <tbody>
    @for (row of data?.data | keyvalue; track row.key) {
      <tr>
        <td>{{row.value.name}}</td>
        <td>{{row.value.description}}</td>
        <td>{{row.value.measured | significantNumbers:true:3}}</td>
        <td>{{row.value.adjusted | significantNumbers:true:3}}</td>
        <td>{{row.value.error | significantNumbers:true:3}}</td>
      </tr>
    }
  </tbody>
</table>
